import ApiService from "@/core/services/api.service";
// action types
export const CREATE_TASK_JIRA = "createTaskJira";
// mutation types

export const SET_ERROR = "setError";

const state = {
  errors: [],
  
};

const actions = {
  
  [CREATE_TASK_JIRA](context, task) {
    return new Promise((resolve, reject) => {
    ApiService.setHeader();
    ApiService.post({action:`/api/Task/v1/task/`}, task)
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  
};

export default {
  state,
  actions,
  mutations
};
